export interface ReportIssueContext {
  title?: string;
  message: string;
  applicationReference?: string;
  applicationType?: string;
  metadata?: Record<string, string>;
  requestPayload?: unknown;
  responseBody?: unknown;
}

export function toTicketPayloadRecord(value: unknown): Record<string, unknown> | undefined {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }

  let safe: unknown;

  try {
    safe = JSON.parse(
      JSON.stringify(value, (_key, item: unknown) => {
        if (
          (typeof File !== 'undefined' && item instanceof File) ||
          (typeof Blob !== 'undefined' && item instanceof Blob)
        ) {
          return `[file: ${(item as File).name ?? 'blob'}]`;
        }

        return item;
      }),
    );
  } catch {
    return { value: String(value) };
  }

  if (safe === null || safe === undefined) {
    return undefined;
  }

  return typeof safe === 'object' && !Array.isArray(safe)
    ? (safe as Record<string, unknown>)
    : { value: safe };
}

export function extractErrorResponseBody(error: unknown): unknown {
  if (typeof error === 'object' && error !== null && 'error' in error) {
    const body = (error as { error?: unknown }).error;

    if (body !== null && body !== undefined) {
      return body;
    }
  }

  return error instanceof Error ? { message: error.message } : undefined;
}
